import { Fragment, ReactNode, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader } from 'components';
import { AppConfigArea } from 'enums';
import { TranslationNamespace } from 'i18n';
import { AppConfig } from 'types';

import { ConfigDetailsDialog } from './ConfigDetailsDialog';

type Props = {
  area: AppConfigArea;
  children: ReactNode;
};

export const ConfigsPage: React.FC<Props> = ({ area, children }) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });

  const [createDialogProps, setCreateDialogProps] = useState<{
    open: boolean;
    data?: Partial<AppConfig>;
  }>({ open: false });

  const handleCreateClick = useCallback(() => {
    setCreateDialogProps({
      open: true,
      data: { area },
    });
  }, [area]);

  return (
    <Fragment>
      <PageHeader
        title={t('title')}
        divider={false}
        rightContentButton={{ onClick: handleCreateClick }}
      />
      {children}
      <ConfigDetailsDialog
        {...createDialogProps}
        onClose={() => setCreateDialogProps({ open: false })}
      />
    </Fragment>
  );
};
